import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <main className="mx-auto flex min-h-screen max-w-prose flex-col justify-center px-6">
      <p className="text-sm uppercase tracking-widest text-ink-subtle">404</p>
      <h1 className="mt-2 text-3xl">That page does not exist.</h1>
      <Link to="/" className="mt-6 self-start text-accent-600 underline underline-offset-4">
        Back to the start
      </Link>
    </main>
  );
}
